import React, { FC, useEffect, useState } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { Header, Title } from 'containers/CourtManagerAssignedExpertise/style';
import { translate } from 'containers/services/translate';
import messages from 'containers/ProvisionalClaimsPage/messges';
import { useDispatch, useSelector } from 'react-redux';
import {
  requestUpdateClaimNumber,
  requestGetProvisionalClaimDetails,
  setProvisionalClaimReference,
  requestValidateProvisionalLiaison,
  requestRejectProvisionalLiaison,
} from 'containers/ProvisionalClaimRecap/actions';
import { get } from 'lodash';
import { makeSelectProvisionalClaimDetails } from 'containers/ProvisionalClaimRecap/selectors';
import ProvisionalClaimInfo from 'containers/ProvisionalClaimRecap/ProvisionalClaimInfo';
import { Container, StyledGrid } from 'containers/ProvisionalClaimRecap/style';
import DropDownDecisionMenu from 'components/SahamDropDown/DropDownDecisionMenu';
import MissionDrawer from 'containers/ProvisionalClaimRecap/Mission/MissionDrawer';
import {
  makeSelectKeycloakToken,
  makeSelectListings,
} from 'containers/AppContainer/selectors';
import { selectedLoader } from 'containers/AppContainer/Loader/selectors';
import { LOADERS } from 'containers/AppContainer/Loader/constants';
import SahamLoader from 'containers/AppContainer/Loader';
import currentIntervenantStorage from 'containers/services/security/current-intervenant-storage';
import MissionRecap from 'containers/ProvisionalClaimRecap/Mission/MissionRecap';
import ExpertiseRecap from 'containers/ProvisionalClaimRecap/Mission/ExpertiseRecap';
import { Dialog } from 'containers/CourtManagerAssignedClaims/styled-components';
import { pushTo } from 'containers/services/routes-helper';
import { PAGES } from 'routes';
import { isLawyer } from 'containers/AppContainer/utils';
import { TextField } from '@material-ui/core';
import { toast } from 'react-toastify';
import {
  CLAIM_STATUS,
  PROVISIONAL_CLAIM_STATUS,
} from 'containers/data-structure';
import VictimDrawer from 'containers/ProvisionalClaimRecap/Victim/VictimDrawer';

export interface ProvisionalClaimRecapProps {
  intl: IntlShape;
  match: { params: { provisionalClaimId: number } };
}

const ProvisionalClaimRecap: FC<ProvisionalClaimRecapProps> = (
  props,
): JSX.Element => {
  const [dropDown, setDropDown] = useState<null | HTMLElement>(null);
  const [openDrawerMission, setOpenDrawerMission] = useState(false);
  const [openDrawerVictim, setOpenDrawerVictim] = useState(false);
  const [isPreOpenDialogOpen, setIsPreOpenDialogOpen] = useState(false);
  const [isAddClaimNumberDialogOpen, setIsAddClaimNumberDialogOpen] = useState(
    false,
  );
  const [
    isValidateLiaisonDialogOpen,
    setIsValidateLiaisonDialogOpen,
  ] = useState(false);
  const [isRejectLiaisonDialogOpen, setIsRejectLiaisonDialogOpen] = useState(
    false,
  );
  const [claimNumber, setClaimNumber] = useState('');
  const listings = useSelector(makeSelectListings());
  const dispatch = useDispatch();
  const provisionalClaimId = get(props, [
    'match',
    'params',
    'provisionalClaimId',
  ]);
  const isIntervenant = !!currentIntervenantStorage.get();
  const token = useSelector(makeSelectKeycloakToken());
  useEffect(() => {
    dispatch(
      requestGetProvisionalClaimDetails(provisionalClaimId, isIntervenant),
    );
  }, [provisionalClaimId, dispatch, token]);

  const provisionalClaimDetails = useSelector(
    makeSelectProvisionalClaimDetails(),
  );
  const loaders = useSelector(selectedLoader);
  const isLoading = get(loaders, LOADERS.PROVISIONAL_CLAIM_DETAILS, false);
  const dropDownMenuElements = [
    {
      title: translate(messages.AssignExpertTitle, props),
      action: () => {
        setOpenDrawerMission(true);
      },
    },
    ...(get(provisionalClaimDetails, 'claim.status', null) ===
      CLAIM_STATUS.VALIDATED &&
    !!get(provisionalClaimDetails, 'claim.claimNumber', null)
      ? [
          {
            title: translate(
              messages.ProvisionalClaimRecapActionsValidateLiaison,
              props,
            ),
            action: () => {
              setIsValidateLiaisonDialogOpen(true);
            },
          },
          {
            title: translate(
              messages.ProvisionalClaimRecapActionsRejectLiaison,
              props,
            ),
            action: () => {
              setIsRejectLiaisonDialogOpen(true);
            },
          },
        ]
      : []),
    {
      title: translate(messages.addVictim, props),
      action: () => {
        setOpenDrawerVictim(true);
      },
    },
  ];
  const handleToggleDrawer = () => {
    setOpenDrawerMission(!openDrawerMission);
  };

  const handleValidatePreOpenClaimDialog = () => {
    setIsPreOpenDialogOpen(false);
    dispatch(
      setProvisionalClaimReference(
        get(provisionalClaimDetails, 'reference', ''),
      ),
    );
    pushTo(`${PAGES.LAWYER_HOME}`)();
  };

  const handleClosePreOpenClaimDialog = () => {
    setIsPreOpenDialogOpen(false);
  };
  const failedCallBack = () => {
    setIsAddClaimNumberDialogOpen(false);
    toast.error(
      translate(messages.ProvisionalClaimRecapDialogToastErrorMessage, props),
    );
  };
  const handleValidateAddClaimNumberDialog = () => {
    setIsAddClaimNumberDialogOpen(false);
    dispatch(
      requestUpdateClaimNumber(provisionalClaimId, claimNumber, failedCallBack),
    );
  };

  const handleCloseAddClaimNumberDialog = () => {
    setIsAddClaimNumberDialogOpen(false);
  };
  const lawyerDropDownMenuElements = [
    {
      title: translate(
        messages.ProvisionalClaimRecapActionsPreopenClaim,
        props,
      ),
      action: () => {
        setIsPreOpenDialogOpen(true);
      },
    },
    {
      title: translate(
        messages.ProvisionalClaimRecapActionsAddClaimNumber,
        props,
      ),
      action: () => {
        setIsAddClaimNumberDialogOpen(true);
      },
    },
  ];
  const handleValidateLiaison = () => {
    dispatch(
      requestValidateProvisionalLiaison(
        get(provisionalClaimDetails, 'id', null),
        () => {
          setIsValidateLiaisonDialogOpen(false);
        },
      ),
    );
  };
  const handleRejectLiaison = () => {
    dispatch(
      requestRejectProvisionalLiaison(
        get(provisionalClaimDetails, 'id', null),
        () => {
          setIsRejectLiaisonDialogOpen(false);
        },
      ),
    );
  };

  const handleToggleVictimDrawer = () => {
    setOpenDrawerVictim(!openDrawerVictim);
  };

  return (
    <>
      <StyledGrid>
        {!isLawyer() &&
          get(provisionalClaimDetails, 'status') !==
            PROVISIONAL_CLAIM_STATUS.MAPPED && (
            <DropDownDecisionMenu
              setDropDown={setDropDown}
              dropDown={dropDown}
              label={translate(messages.managerActionTitle, props)}
              menuElements={dropDownMenuElements}
            />
          )}
        {isLawyer() && !get(provisionalClaimDetails, 'claimNumber', null) && (
          <DropDownDecisionMenu
            setDropDown={setDropDown}
            dropDown={dropDown}
            label={translate(messages.managerActionTitle, props)}
            menuElements={lawyerDropDownMenuElements}
          />
        )}
        <MissionDrawer
          open={openDrawerMission}
          handleToggleDrawer={handleToggleDrawer}
          listings={listings}
          assignedLawyer={null}
          provisionnalClaimId={get(provisionalClaimDetails, 'id')}
          victims={get(provisionalClaimDetails, 'victims', [])}
        />
        <VictimDrawer
          open={openDrawerVictim}
          handleToggleDrawer={handleToggleVictimDrawer}
          listings={listings}
          assignedLawyer={null}
          provisionalClaimId={get(provisionalClaimDetails, 'id')}
        />
      </StyledGrid>
      {isLoading ? (
        <SahamLoader withOpacity={false} />
      ) : (
        <>
          <Container>
            <Header>
              <Title>
                {translate(
                  messages.monitoringProvisionalClaimRecapTitle,
                  props,
                  {
                    reference: get(provisionalClaimDetails, 'reference', ''),
                  },
                )}
              </Title>
            </Header>
            <ProvisionalClaimInfo
              provisionalClaimDetails={provisionalClaimDetails}
            />
          </Container>
          <MissionRecap
            missions={get(provisionalClaimDetails, 'missions', [])}
            listings={listings}
          />
          <ExpertiseRecap
            recap={get(provisionalClaimDetails, 'missions', [])}
          />
          {isPreOpenDialogOpen && (
            <Dialog
              open={isPreOpenDialogOpen}
              handleClose={handleClosePreOpenClaimDialog}
              handleValidate={handleValidatePreOpenClaimDialog}
              title={translate(
                messages.ProvisionalClaimRecapActionsPreopenClaimDialogTitle,
                props,
              )}
              confirmTitle={translate(
                messages.ProvisionalClaimRecapActionsPreopenClaimDialogConfirm,
                props,
              )}
              cancelTitle={translate(
                messages.ProvisionalClaimRecapActionsPreopenClaimDialogCancel,
                props,
              )}
            >
              <div>
                {translate(
                  messages.ProvisionalClaimRecapActionsPreopenClaimDialogContent,
                  props,
                )}
              </div>
            </Dialog>
          )}
          {isAddClaimNumberDialogOpen && (
            <Dialog
              open={isAddClaimNumberDialogOpen}
              handleClose={handleCloseAddClaimNumberDialog}
              handleValidate={handleValidateAddClaimNumberDialog}
              title={translate(
                messages.ProvisionalClaimRecapDialogAddClaimNumberDialogTitle,
                props,
              )}
              confirmTitle={translate(
                messages.ProvisionalClaimRecapActionsPreopenClaimDialogConfirm,
                props,
              )}
              cancelTitle={translate(
                messages.ProvisionalClaimRecapActionsPreopenClaimDialogCancel,
                props,
              )}
            >
              <TextField
                fullWidth
                label={translate(
                  messages.ProvisionalClaimRecapDialogClaimNumberInput,
                  props,
                )}
                value={claimNumber}
                onChange={e => setClaimNumber(e.target.value)}
              />
            </Dialog>
          )}
          {isValidateLiaisonDialogOpen && (
            <Dialog
              open={isValidateLiaisonDialogOpen}
              handleClose={() => {
                setIsValidateLiaisonDialogOpen(false);
              }}
              handleValidate={handleValidateLiaison}
              title={translate(
                messages.ProvisionalClaimRecapActionsPreopenClaimDialogTitle,
                props,
              )}
              confirmTitle={translate(
                messages.ProvisionalClaimRecapActionsPreopenClaimDialogConfirm,
                props,
              )}
              cancelTitle={translate(
                messages.ProvisionalClaimRecapActionsPreopenClaimDialogCancel,
                props,
              )}
            >
              <div>
                {translate(
                  messages.ProvisionalClaimRecapActionsValidateLiaisonDialogContent,
                  props,
                )}
              </div>
            </Dialog>
          )}
          {isRejectLiaisonDialogOpen && (
            <Dialog
              open={isRejectLiaisonDialogOpen}
              handleClose={() => {
                setIsRejectLiaisonDialogOpen(false);
              }}
              handleValidate={handleRejectLiaison}
              title={translate(
                messages.ProvisionalClaimRecapActionsPreopenClaimDialogTitle,
                props,
              )}
              confirmTitle={translate(
                messages.ProvisionalClaimRecapActionsPreopenClaimDialogConfirm,
                props,
              )}
              cancelTitle={translate(
                messages.ProvisionalClaimRecapActionsPreopenClaimDialogCancel,
                props,
              )}
            >
              <div>
                {translate(
                  messages.ProvisionalClaimRecapActionsRejectLiaisonDialogContent,
                  props,
                )}
              </div>
            </Dialog>
          )}
        </>
      )}
    </>
  );
};

export default injectIntl(ProvisionalClaimRecap);
